import { render, staticRenderFns } from "./AccountImports.vue?vue&type=template&id=684851ed&"
import script from "./AccountImports.vue?vue&type=script&lang=js&"
export * from "./AccountImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports